import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ResponsiveDialog, Form, FormTextField, HandlerError, LoadingButton } from '@dfl/mui-react-common';
import { Button, DialogActions } from '@mui/material';
import useBusinessAccountRequestRejectForm from './useBusinessAccountRequestRejectForm';

type BusinessAccountRequestRejectModalProps = {
  open: boolean;
  onClose: () => void;
  requestId: string;
};

const BusinessAccountRequestRejectModal = ({ open, onClose, requestId }: BusinessAccountRequestRejectModalProps) => {
  const { t } = useTranslation('businessAccountRequest');
  const { control, error, isLoading, rejectionReason, onSubmit } = useBusinessAccountRequestRejectForm(
    requestId,
    onClose,
  );

  return (
    <ResponsiveDialog open={open} onClose={onClose} title={t('reject')} subtitle={t('rejectSubtitle')}>
      <HandlerError error={error} />
      <Form onSubmit={onSubmit} control={control} isLoading={isLoading} size='small' dark>
        <FormTextField
          fullWidth
          autoFocus
          required
          multiline
          rows={3}
          name='rejectionReason'
          label={t('fields.rejectionReason')}
        />
      </Form>
      <DialogActions sx={{ px: 0 }}>
        <Button onClick={onClose}>{t('common:cancel')}</Button>
        <LoadingButton
          onClick={onSubmit}
          disabled={!rejectionReason}
          loading={isLoading}
          variant='contained'
          color='error'
        >
          {t('reject')}
        </LoadingButton>
      </DialogActions>
    </ResponsiveDialog>
  );
};

export default memo(BusinessAccountRequestRejectModal);
